import { _ROLES_BACK, _SWAL_ICONS } from "../../utils/constants";
import { _ROUTES } from "../../utils/_routes_constants";
import AgGridDepreciation from "../../components/budget/depreciation/AgGridDepreciation";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { useEffect, useState } from "react";
import {
  CATEGORY_DEPRECIATION,
  createSaveDataDepreciation,
} from "../../utils/savedDataConstant/depreciationSaveConstants";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";
import { DataService } from "../../services/DataService";
import { createToast } from "../../utils/toast";

export default function InputDepreciation() {
  const [saveData, setSaveData] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [params, setParams] = useState({});
  const [sortedDataAP, setSortedDataAP] = useState([]);
  const save_name_category = CATEGORY_DEPRECIATION;
  const dataService = new DataService();

  const handleParamsChange = (newParams) => {
    setParams(newParams);
  };

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData
        ?.map((d) => {
          if (!d) return null;

          const payload = {
            activityName: d.group,
            siteId: params.site,
            theme: d.rowName,
            months: {},
          };

          for (let i = 1; i <= 12; i++) {
            payload.months[i] = d[i] || null;
          }

          return payload;
        })
        .filter((item) => item !== null);

      sendToFinancialData(modifiedData, save_name_category, () => {
        setSaveData([]);
      });
    }
  }, [saveData]);

  useEffect(() => {
    if (sortedDataAP.length === 0) {
      dataService
        .fetchData(_ROUTES.DEPRECIATION, {}, (data) => {
          setSortedDataAP(createSaveDataDepreciation(data));
        })
        .catch((error) => {
          createToast(_SWAL_ICONS.error, error.message);
        });
    }
  }, [rowsData]);

  return (
    <>
      <BaseBudgetInput
        title="Input Depreciation"
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
        userRole={_ROLES_BACK._ROLE_DEPRECIATION}
        enableFlag="dataEntryEnableDepreciations"
        TableComponent={AgGridDepreciation}
        tableComponentProps={{
          rowsData,
          setRowsData,
          params,
        }}
        saveData={saveData}
        setSaveData={setSaveData}
        onParamsChange={handleParamsChange}
        includeBaseBudgetSave={true}
        arrayData={sortedDataAP}
        saveNameCategory={save_name_category}
        filters={[
          {
            key: "site",
            route: _ROUTES.SITES,
            defaultValue: "",
            label: "Site",
            queryParams: {
              active: 1,
              "groups[]": "select:get",
              "order[name]": "ASC",
            },
          },
        ]}
      />
    </>
  );
}
